var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97 91",
    width: 97,
    height: 91,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-150-1999h1366v3181h-1366z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#d25627}.b{fill:#cb8252}.c{fill:#a56a43}.d{fill:#cf976a}.e{fill:#fff}.f{fill:#e57e25}.g{fill:#f29c1f}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2.7 51.4l15.5-10.8c0.6-0.6 1.4-1 2.3-1h31.3c0.9 0 1.7 0.3 2.4 1l-10.6 17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m44 51.4l15.4-10.8c0.6-0.6 1.5-1 2.3-1h31.4c0.9 0 1.7 0.3 2.3 1l-13.2 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m82.2 52.1l13.2-11.5c0.6 0.6 1 1.4 1 2.3v31.4c0 0.8-0.4 1.7-1 2.3l-13.2 13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m83.2 54.5v33c0 1.8-1.5 3.2-3.3 3.3h-34.7c-1.8 0-3.3-1.5-3.3-3.3v-33c0-1.4 0.8-2.6 2.1-3.1q0.6-0.2 1.2-0.2h34.7c1.8 0 3.3 1.4 3.3 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m49.7 78h8c0.5 0 1 0.4 1 1v4c0 0.6-0.5 1-1 1h-8c-0.6 0-1-0.4-1-1v-4c0-0.6 0.4-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m76.6 79.2h-5c-0.9 0-1.6-0.7-1.6-1.6 0-1 0.7-1.7 1.6-1.7h5c0.9 0 1.6 0.7 1.6 1.7 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m76.6 85.8h-5c-0.9 0-1.6-0.7-1.6-1.6 0-1 0.7-1.7 1.6-1.7h5c0.9 0 1.6 0.7 1.6 1.7 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m41.9 54.5v33c0 1.8-1.4 3.2-3.3 3.3h-34.6c-1.8 0-3.3-1.5-3.3-3.3v-33c0-1.4 0.8-2.6 2-3.1q0.6-0.2 1.3-0.2h34.6c1.9 0 3.3 1.4 3.3 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m8.7 78h8c0.5 0 1 0.4 1 1v4c0 0.6-0.5 1-1 1h-8c-0.6 0-1-0.4-1-1v-4c0-0.6 0.4-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m35.3 79.2h-4.9c-0.9 0-1.7-0.7-1.7-1.6 0-1 0.8-1.7 1.7-1.7h4.9c0.9 0 1.7 0.7 1.7 1.7 0 0.9-0.8 1.6-1.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m35.3 85.8h-4.9c-0.9 0-1.7-0.7-1.7-1.6 0-1 0.8-1.7 1.7-1.7h4.9c0.9 0 1.7 0.7 1.7 1.7 0 0.9-0.8 1.6-1.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m24.2 11.8l15.4-10.8c0.6-0.7 1.5-1 2.3-1h31.4c0.9 0 1.7 0.3 2.3 1l-13.2 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m62.4 12.5l13.2-11.5c0.6 0.6 1 1.4 1 2.3v31.4c0 0.8-0.4 1.7-1 2.3l-13.2 13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m62.4 50.2l-0.1 0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m61.1 0l-14.8 11.6h-5.4l14.8-11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m63.4 14.9v33c0 1.8-1.5 3.2-3.3 3.3h-34.7c-1.8-0.1-3.3-1.5-3.3-3.3v-33c0-1.4 0.8-2.6 2.1-3.1q0.6-0.3 1.2-0.2h34.7c1.8 0 3.3 1.4 3.3 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m29.7 38h8c0.5 0 1 0.4 1 1v5c0 0.6-0.5 1-1 1h-8c-0.6 0-1-0.4-1-1v-5c0-0.6 0.4-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m56.8 39.6h-5c-0.9 0-1.6-0.7-1.6-1.6 0-1 0.7-1.7 1.6-1.7h5c0.9 0 1.6 0.7 1.6 1.7 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m56.8 46.2h-5c-0.9 0-1.6-0.7-1.6-1.6 0-1 0.7-1.7 1.6-1.7h5c0.9 0 1.6 0.7 1.6 1.7 0 0.9-0.7 1.6-1.6 1.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.9f6bbe54ea3dc0008162d67635c5b0f9.svg";
export { ForwardRef as ReactComponent };